
<nav
  class="font-rubik h-full flex flex-col justify-between pl-6 pt-10 pb-auto"
  :aria-labelledby="'dropdown-' + activeDropdown"
>
  <div>
    <h3
      :id="'dropdown-' + activeDropdown"
      class="dropdown-name mb-5"
    >
      {{ currentDropdown.name.toUpperCase() }}
    </h3>

    <ul>
      <li
        v-for="(link, index) in currentDropdown.links"
        :key="index"
        role="none"
      >
        <a
          class="dropdown-link flex items-center mb-3 transition-all"
          :href="link.slug"
          role="menuitem"
        >
          <span
            class="dropdown-link-name"
            :class="{ 'always-blue': link.slug === '/service-areas' }"
          >
            {{ link.title }}
          </span>
          <img
            class="h-4 ml-1"
            src="@/images/service-area-cards/arrow-outward.svg"
            alt=""
            aria-hidden="true"
          />
        </a>
      </li>
    </ul>
  </div>

  <div
    v-if="showSeeAllLink"
    class="flex items-center gap-2 mb-2"
  >
    <a
      class="see-all-link"
      :href="showSeeAllLink.slug"
      :aria-label="`See all ${currentDropdown.name} articles`"
    >
      See All
    </a>
    <img
      src="@/images/header/chevron-right.svg"
      alt=""
      aria-hidden="true"
    />
  </div>
</nav>
